<template>
  <el-main>
    <div class="events">
      <div class="title justify-between align-center">
        <h3>{{ title }}</h3>
        <!-- <div class="more little_hand">
        发布于{{ $dayjs(item.publish_time).format("YYYY-MM-DD") }}
      </div> -->
      </div>
      <!-- <p class="desc">{{ item.desctext }}</p> -->
      <!-- <swiper :id="item.id" /> -->
      <el-row :gutter="20" v-if="isPc">
        <el-col :span="8" v-for="(it, idx) in eventsArticleArr" :key="idx">
          <div class="news_item" @click="fnToArticle(it.article_id)">
            <el-image :src="it.main_image[0]" fit="cover"></el-image>
            <div class="news_item_info">
              <h3>{{ it.title }}</h3>
              <div class="news_item_time">
                <div>{{ $dayjs(it.publish_time).format("YYYY-MM-DD") }}</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <ul class="m-list" v-else>
        <li
          v-for="(item, index) in eventsArticleArr"
          :key="index"
          class="m-news_item"
          @click="fnToArticle(item.article_id)"
        >
          <el-image :src="item.main_image[0]" fit="cover"></el-image>
          <div class="m-news_item_info">
            <h3>{{ item.title }}</h3>
            <div class="m-news_item_time">
              <div>{{ $dayjs(item.publish_time).format("YYYY-MM-DD") }}</div>
              <!-- <div class="el-icon-view">{{ item.times }}</div> -->
            </div>
            <!-- <div class="news_item_desc" v-if="item.desctext">
                {{ item.desctext }}
              </div> -->
          </div>
        </li>
      </ul>
    </div>
  </el-main>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      title: "",
      eventsArticleArr: [],
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  mounted() {
    this.title = window.sessionStorage.getItem("title");
    this.getEventsArticles();
  },
  methods: {
    // 获取大事记列表新闻
    async getEventsArticles() {
      const { data: res } = await this.$http.get(
        `/api/v2/article/timeMemoryItemList/${this.$route.params.id}`
      );
      console.log(res);
      if (res.code !== "200") return this.$message.error(res.msg);
      this.eventsArticleArr = res.data.map((item) => {
        item.main_image = JSON.parse(item.main_image);
        item.main_image = item.main_image.map((img) =>
          !/^http/.test(img) ? this.$imgUrl + img : img
        );
        return item;
      });
    },
    fnToArticle(article_id) {
      // // console.log(article_id)
      this.$router.push({
        path: `/article/${article_id}`,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.el-main {
  width: 1000px;
  padding-top: 50px;
  margin-bottom: 0;
  padding-bottom: 50px;
}
.events {
  position: relative;
  padding: 20px 0;
  overflow: hidden;
  .title {
    margin-bottom: 5px;
    padding: 0 20px;
    margin-bottom: 20px;

    position: relative;
    z-index: 99;
    h3 {
      font-family: MicrosoftYaHei;
      font-size: 20px;
      color: #222;
      letter-spacing: 0;
      font-weight: 400;
      display: flex;
      align-items: center;
    }
    h3::before {
      content: "";
      display: inline-block;
      width: 4px;
      height: 20px;
      background: #20317f;
      transform: rotate(15deg);
      margin-right: 10px;
    }
    .more {
      opacity: 0.5;
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #2c2d33;
      letter-spacing: 0;
      text-align: justify;
      font-weight: 400;
      position: relative;
      z-index: 99;
    }
  }
  .desc {
    opacity: 0.5;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    color: #2c2d33;
    letter-spacing: 0;
    text-align: justify;
    line-height: 20px;
    font-weight: 400;
    padding-left: 20px;
    position: relative;
    z-index: 99;
  }
}
.news_item {
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 20px;
  .el-image {
    width: 100%;
    // height: auto;
    height: 220px;
    object-fit: cover;
    border-radius: 8px 8px 0 0;
  }
  .news_item_info {
    padding: 10px 15px 15px;
    height: 93px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: -webkit-fill-available;
    h3 {
      font-size: 22px;
      line-height: 34px;
      margin-bottom: 10px;
      font-family: MicrosoftYaHei;
      color: #222222;
      font-weight: 400;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .news_item_time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      color: #333333;
      margin-right: 27px;
      font-family: MicrosoftYaHei;
      color: #888888;
      font-weight: 400;
    }
    .news_item_desc {
      font-size: 14px;
      color: #414141;
      line-height: 22px;
      margin-top: 23px;
    }
    .el-icon-view:before {
      margin-right: 5px;
    }
  }
}
@media screen and (max-width: 768px) {
  .el-main {
    width: 100%;
    padding-top: 0;
    margin-bottom: 0;
    padding-bottom: 20px;
  }
  .m-list {
    padding: 0 15px;
    background: #fff;
    margin-top: -15px;
    padding-top: 15px;
  }
  .m-news_item {
    padding: 15px 0;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    cursor: pointer;
    .el-image {
      width: 114px;
      height: 76px;
      margin-right: 10px;
      border-radius: 4px;
    }
    h3 {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #222222;
      letter-spacing: 0;
      font-weight: 500;
      line-height: 22px;
      margin-bottom: 10px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }
    .m-news_item_info {
      flex: 1;
    }
    .m-news_item_time {
      font-size: 12px;
      color: #888;
      margin-right: 10px;
    }
  }
  .el-button {
    width: 80%;
    font-size: 14px;
    color: #878787;
    line-height: 22px;
    padding: 10px 0;
    background: #fbfbfb;
    border: none;
    margin: 10px auto;
    display: block;
  }
}
</style>